module.exports = __webpack_public_path__ + "img/teacher1.8d58319e.jpg";